/**!
 * Created by Leonardo Cheslacki on 05/06/2024.
 *
 * MIT License
 *
 * Copyright (c) 2024 cheslacki
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import PropTypes from 'prop-types';

import PageController from './PageController';

import {HelpersIcon} from './../helpers';

import indexConfig from './../../../../config/index.config';

import pageConfig from './../../../../config/page.config';

import WithType from './../WithType';

/**
 * REVIEW helpersIcon in all fla for color.
 */
class PageCurrent extends PageController {
    /**
     *
     * @param props
     * @param main
     */
    constructor(props, main) {
        super(props);

        this.props = props;
        this.main = main;

        this.state = {};

        this.$helpersIcon = HelpersIcon(this)({current_name: 'page'});

        PageCurrent._this = this;
    };

    $functions = {
        /**
         *
         * @param event
         */
        handle: function (event) {

        }
    };

    /**
     *
     * @returns {{paginates: (string|*), paginate: *, defaultPaginate: *}}
     */
    getPaginate = () => {
        const
            paginates = this.verifyField(this.getCurrentIndex(), 'paginates'),
            defaultPaginate = this.getDefaultIndex(paginates),
            paginate = this.getCurrentIndex(paginates) || defaultPaginate;

        return {defaultPaginate, paginate, paginates};
    };

    /**
     * Not usage direct.
     * @param execute
     */
    defaultInit = (execute = null) => {
        const
            {current_name, frame, color_icon} = this.props,
            _this_current = this.get();

        AllTap.$current_name = current_name;

        this.gotoAndStopFrame(_this_current, frame);

        this.pageIn();

        AllTap.emit('dynamic_frame', {frame: frame});

        this.$helpersIcon.setIcon(_this_current, color_icon);

        this.$helpersIcon.setIcon(this.getFrame(), color_icon);

        (typeof (execute) === 'function') && execute();

        /**
         * Preloader
         */
        AllTap.emit('process_end', {}, current_name);
    };

    /**
     * Not usage direct.
     * @param execute
     * @param dynamic
     * @param current_page
     */
    defaultPaginateInit = (execute = null, dynamic = false, current_page = null) => {
        const
            {current_name, frame, color_icon} = this.props,
            stagePaginate = AllTap.$stagePaginate({current_name: current_name, current_page: current_page}),
            _this_current = this.get();

        AllTap.$current_name = current_name;

        this.gotoAndStopFrame(_this_current, frame);

        this.pageIn();

        stagePaginate.mainPaginate(dynamic);

        this.$helpersIcon.setIcon(_this_current, color_icon);

        this.$helpersIcon.setIcon(this.getFrame(), color_icon);

        (typeof (execute) === 'function') && execute(stagePaginate);

        /**
         * Preloader
         */
        AllTap.emit('process_end', {}, current_name);
    };

    /**
     * Single page.
     * Included helpersIcon color.
     */
    initCover = this.defaultInit;

    /**
     * Single page.
     * Included helpersIcon color.
     * For all pages simple.
     */
    initRecord = this.defaultInit;

    /**
     * Paginate.
     * Included helpersIcon color.
     * For all pages simple.
     */
    initPaginate = this.defaultPaginateInit;

    initMenu = () => {
        const {btn_menu01, btn_menu02} = AllTap.getState('_this_menu');

        this.setHandleMouseDown(btn_menu01, () => {
            this.pageOut();
            AllTap.$current_name_sub = 'planta01';
            AllTap.$current_frame_sub = 1;
        });

        this.setHandleMouseDown(btn_menu02, () => {
            this.pageOut();
            AllTap.$current_name_sub = 'planta02';
            AllTap.$current_frame_sub = 2;
        });

        /**
         * Preloader
         */
        AllTap.emit('process_end', {}, this.props.current_name);
    };

    initPortal = () => {
        this.defaultInit(() => {
            const {btn_01, btn_02} = this.getFrame();

            this.setHandleMouseDown(btn_01, () => {
                window.open('http://reserva-web.local', '_self');
            });

            this.setHandleMouseDown(btn_02, () => {
                window.open('http://reserva-bosque-web.local', '_self');
            });
        });
    };

    /**
     * Single page.
     * Included stageGallery and helpersIcon color.
     */
    initGallery = () => {
        this.defaultInit(() => {
            AllTap.$stageGallery({
                current_name: this.props.current_name,
                xml: this.verifyField(this.getCurrentIndex(), 'xml')
            }).mainGallery();
        });
    };

    /**
     * Paginate.
     * Included stageGallery and helpersIcon color.
     * @param current_page
     */
    initGalleryPaginate = (current_page) => {
        this.defaultPaginateInit(() => {
            const
                {current_name} = this.props,
                {defaultPaginate, paginate} = this.getPaginate();

            if (this.inArray([2, 3], paginate.frame)) {
                AllTap.$stageGallery({
                    current_name: current_name,
                    xml: this.verifyField(this.getCurrentIndex(), 'xml')
                }).mainGallery();

                const anim_container = document.getElementById('animation_container');

                AllTap.$element_img = document.createElement('IMG');

                this.setAttributes(AllTap.$element_img, {
                    id: 'close_overlay_container',
                    alt: 'close',
                    src: this.getUriImage('close.png'),
                    width: this.calcSize(1, stage.scaleX, 40, false, 'int'),
                    height: this.calcSize(1, stage.scaleY, 40, false, 'int')
                });

                const close = () => {
                    this.removeListener('click', 'click-close-overlay-container');

                    this.pageOut();

                    AllTap.$current_name_sub = this.verifyField(defaultPaginate, 'name');
                    AllTap.$current_frame_sub = this.verifyField(defaultPaginate, 'frame');
                    AllTap.$element_img.remove();
                };

                this.removeListener('click', 'click-close-overlay-container', () => {
                    this.addListener(AllTap.$element_img, 'click', 'click-close-overlay-container', close);
                });

                anim_container.appendChild(AllTap.$element_img);
            }
        });
    };

    /**
     * Single page.
     * Included stagePin and helpersIcon color.
     */
    initImplantation = () => {
        this.defaultInit(() => {
            const paginate = this.getCurrentIndex();
            AllTap.$stagePin({
                current_name: this.props.current_name,
                xml: this.verifyField(paginate, 'xml'),
                content_text: this.verifyField(paginate, 'content_text')
            }).mainPin();
        });
    };

    /**
     * Paginate.
     * Included helpersIcon color.
     */
    initImplantationPaginate = () => {
        this.defaultPaginateInit(() => {
            const
                _this_current = this.get(),
                {current_name, color_icon} = this.props,
                {paginate, paginates} = this.getPaginate();

            AllTap.$stagePin({
                current_name: current_name,
                xml: this.verifyField(paginate, 'xml'),
                content_text: this.verifyField(paginate, 'content_text')
            }).mainPin();

            for (let property of paginates) {
                this.$helpersIcon.setIcon(_this_current, color_icon, property.frame);
            }

            this.$helpersIcon.disabledAnimate(_this_current)(paginate.frame);
        });
    };

    /**
     * Paginate.
     * Included stagePaginate, layerDifferential, layerCamera, layerPin and helpersIcon color.
     */
    initPlantPaginate = () => {
        this.defaultPaginateInit((stagePaginate) => {
            const
                _this_current = this.get(),
                {current_name, color_icon} = this.props,
                {paginate, paginates} = this.getPaginate();

            // if (paginate.frame === 2) {
            //     AllTap.$stageGallery({
            //         current_name: current_name,
            //         xml: this.verifyField(paginate, 'xml')
            //     }).mainGallery();
            // }

            if (this.verifyField(paginate, 'active.differential')) {
                const layerDifferential = AllTap.$layerDifferential({
                    current_name: current_name,
                    enabled: this.verifyField(paginate, 'active.differential_enabled')
                });
                layerDifferential.mainDifferential();
                stagePaginate.setState({...stagePaginate.state, differential: layerDifferential});
            }

            if (this.verifyField(paginate, 'active.camera')) {
                const layerCamera = AllTap.$layerCamera({current_name: current_name});
                layerCamera.mainCamera();
                stagePaginate.setState({...stagePaginate.state, camera: layerCamera});
            }

            if (this.verifyField(paginate, 'active.pin')) {
                const layerPin = AllTap.$layerPin({current_name: current_name});
                layerPin.mainPin();
                stagePaginate.setState({...stagePaginate.state, pin: layerPin});
            }

            for (let property of paginates) {
                this.$helpersIcon.setIcon(_this_current, color_icon, property.frame);
            }

            this.$helpersIcon.disabledAnimate(_this_current)(paginate.frame);
        });
    };

    initLocalizationDynamic = () => {
        this.defaultPaginateInit(() => {
            this.main.on('dynamic_paginate', ({number_current, current_name}) => {
                const
                    _this_frame = this.getFrame(),
                    {occ_convenience, occ_pseudo} = _this_frame;

                if (current_name === this.props.current_name) {
                    if (number_current === 2) {
                        occ_convenience.gotoAndStop('empty');
                        occ_pseudo.gotoAndStop('empty');
                        occ_convenience.btn_close.visible = false;

                        this.setHandleMouseDown(occ_convenience.btn_close, () => {
                            this.effectFadeOut(_this_frame, 'occ_convenience', () => {
                                occ_convenience.gotoAndStop('empty');
                                occ_pseudo.gotoAndStop('empty');
                                occ_convenience.btn_close.visible = false;
                            });
                        });

                        for (let i = 1; i < 8; i++) {
                            let occ = _this_frame[`btn_${this.padWithLeadingZeros(i, 2)}`];
                            this.setHandleMouseDown(occ, () => {
                                this.effectFadeIn(_this_frame, 'occ_convenience');
                                this.gotoAndStopFrame(occ_convenience, i);
                                this.gotoAndStopFrame(occ_pseudo, i);
                                occ_convenience.btn_close.visible = true;
                            });
                        }
                    }
                }
            }, this.props.current_name);
        }, true);
    };

    initLocalizationPaginate = () => {
        this.defaultPaginateInit(() => {
            const
                _this_current = this.get(),
                {current_name} = this.props,
                {paginate} = this.getPaginate();

            if (paginate.frame === 1) {
                AllTap.$stageLocalization({
                    current_name: current_name,
                    xml: this.verifyField(paginate, 'xml')
                }).mainLocalization();
            } else if (paginate.frame === 2) {
                const
                    buttons = this.verifyField(_this_current, 'occ_frame_01.occ_marker.occ_buttons.children'),
                    markers = this.verifyField(_this_current, 'occ_frame_01.occ_marker.occ_markers');

                let current_btn, current_marker;

                const showMarker = function (event) {
                    const {button, marker} = this;

                    if (current_btn === button) {
                        current_btn.gotoAndPlay('off');
                        current_marker.gotoAndPlay('off');
                        current_btn = '';
                        current_marker = '';

                        return;
                    } else if (current_btn) {
                        current_btn.gotoAndPlay('off');
                        current_marker.gotoAndPlay('off');
                    }

                    current_btn = button;
                    current_marker = marker;
                    button.gotoAndPlay('on');
                    marker.gotoAndPlay('on');
                }

                buttons.forEach((button) => {
                    const
                        btn_number = parseInt(button.name.split('_')[1]),
                        number = (btn_number < 10) ? `0${btn_number}` : btn_number,
                        marker = markers[`occ_marker_${number}`];

                    button.gotoAndPlay('off');
                    marker.gotoAndPlay('off');
                    button.btn.removeEventListener('click', showMarker);
                    button.btn.addEventListener('click', showMarker.bind({button, marker}));
                });
            } else if (paginate.frame === 3) {
                AllTap.$stageSlider({current_name: current_name, composition_name: paginate.name}).initSlider();
            }
        });
    };

    initProjectPaginate = () => {
        this.defaultPaginateInit((stagePaginate) => {
            const
                _this_current = this.get(),
                _this_frame = this.getFrame(),
                {current_name, color_icon} = this.props,
                {paginate, paginates} = this.getPaginate();

            if (paginate.frame === 1) {
                _this_frame.occ_sector.gotoAndPlay('sector01');

                let children = this.verifyField(_this_frame, 'occ_button.children');

                if (this.isArrayIf(children)) {
                    for (let property of children) {
                        this.setHandleMouseDown(property, () => {
                            _this_frame.occ_sector.gotoAndPlay(`sector${this.padWithLeadingZeros(this.toNumber(property.name), 2)}`);
                        });
                    }
                }
            } else if (this.inArray([2, 6], paginate.frame)) {
                AllTap.$stagePin({
                    current_name: current_name,
                    xml: this.verifyField(paginate, 'xml'),
                    content_text: this.verifyField(paginate, 'content_text')
                }).mainPin();
            } else if (this.inArray([3, 7, 8, 9], paginate.frame)) {
                for (let property of paginates) {
                    this.$helpersIcon.setIcon(_this_current, (paginate.frame === property.frame ? '0xFFFFFF' : color_icon), property.frame);
                }

                this.$helpersIcon.disabledAnimate(_this_current)(paginate.frame);
            }
        });
    };

    initRationalPaginate = () => {
        this.defaultPaginateInit();
        // this.defaultPaginateInit((stagePaginate) => {
        //     AllTap.on('dynamic_paginate', ({number_current, current_name}) => {
        //         if(current_name === this.props.current_name){
        //             if (number_current === 2) {
        //                 const _this_frame = this.getFrame();
        //
        //                 let children = this.verifyField(_this_frame, 'occ_card.occ_button.children');
        //
        //                 if (this.isArrayIf(children)) {
        //                     for (let property of children) {
        //                         this.setHandleMouseDown(property, () => {
        //                             _this_frame.occ_card.gotoAndStop(`card${this.padWithLeadingZeros(this.toNumber(property.name), 2)}`);
        //                         });
        //                     }
        //                 }
        //             }
        //         }
        //     }, this.props.current_name);
        // }, true);
    };

    initInstitutionalPaginate = () => {
        this.defaultPaginateInit(() => {

            const execute = (event, options) => {
                let occ_button = this.verifyField(options, 'occ_button');
                this.openVideo(occ_button, options);
            };

            AllTap.on('dynamic_paginate', ({number_current, current_name}) => {
                if (current_name === this.props.current_name) {
                    if (number_current === 2) {
                        AllTap.$stageSlider({
                            current_name: this.props.current_name,
                            composition_name: this.props.current_name
                        }).initSlider();
                    } else if (number_current === 3) {
                        let {btn_video01} = this.getFrame();

                        this.setHandleMouseDown(btn_video01, execute, {
                            occ_button: btn_video01,
                            name: 'video-01',
                            uri: 'vr-girl.mp4'
                        });
                    }
                }
            }, this.props.current_name);

        }, true);
    };

    /**
     * Paginate.
     * Included stagePaginate, stageView and helpersIcon color.
     */
    initView = () => {
        this.defaultPaginateInit(() => {
            const {current_name} = this.props;
            AllTap.$stageView({
                current_name: current_name,
                xml: this.verifyField(this.getCurrentIndex(), 'xml'),
            }).initView();
        }, true);
    };

    /**
     * Single page.
     * Included stageSun and helpersIcon color.
     */
    initOrientation = () => {
        this.defaultInit(() => {
            const {current_name} = this.props;
            AllTap.$stageSun({current_name: current_name}).mainSun();
        });
    };

    /**
     * Paginate.
     * Included helpersIcon color.
     */
    initOrientationPaginate = (current_page) => {
        this.defaultPaginateInit(() => {
            const
                _this_current = this.get(),
                {current_name, color_icon} = this.props,
                {paginate, paginates} = this.getPaginate();

            AllTap.$stageSun({current_name: current_name, current_page: current_page}).mainSun();

            for (let property of paginates) {
                this.$helpersIcon.setIcon(_this_current, color_icon, property.frame);
            }

            this.$helpersIcon.disabledAnimate(_this_current)(paginate.frame);
        });
    };

    /**
     * Single page.
     * Included stageZoom and helpersIcon color.
     */
    initZoom = () => {
        this.defaultInit(() => {
            AllTap.$stageZoom({current_name: this.props.current_name}).mainZoom();
        });
    };

    /**
     * Single page.
     * Included stageSlider and helpersIcon color.
     */
    initSlider = () => {
        this.defaultInit(() => {
            const {current_name} = this.props;
            AllTap.$stageSlider({current_name: current_name, composition_name: current_name}).mainSlider();
        });
    };

    /**
     * Single page.
     * Included stageScroll and helpersIcon color.
     */
    initScroll = () => {
        this.defaultInit(() => {
            AllTap.$stageScroll({current_name: this.props.current_name}).mainScroll();
        });
    };

    /**
     * Single page.
     * Included stageQuiz and helpersIcon color.
     */
    initQuiz = () => {
        this.defaultInit(() => {
            AllTap.$stageQuiz({current_name: this.props.current_name}).mainQuiz();
        });
    };

    /**
     * Single page.
     * Included stageMemory and helpersIcon color.
     */
    initMemory = () => {
        this.defaultInit(() => {
            AllTap.$stageMemory({current_name: this.props.current_name}).mainMemory();
        });
    };

    /**
     * Single page.
     * Included stageMarquee and helpersIcon color.
     */
    initMarquee = () => {
        this.defaultInit(() => {
            const {current_name} = this.props;
            AllTap.$stageMarquee({current_name: current_name}).mainMarquee();
        });
    };

    /**
     * Single page.
     * Included stage360 and helpersIcon color.
     */
    init360 = () => {
        this.defaultInit(() => {
            const {current_name} = this.props;
            AllTap.$stage360({current_name: current_name}).main360();
        });
    };

    /**
     * REVIEW
     */
    initVideo = () => {
        this.defaultInit(() => {
            const {
                btn_video01,
                btn_video02,
                btn_video03,
                btn_video04,
                btn_video05,
                btn_video06
            } = this.getFrame();

            const execute = (event, options) => {
                let occ_button = this.getObject(options, 'occ_button');
                this.openVideo(occ_button, options);
            };

            this.setHandleMouseDown(btn_video01, execute, {
                occ_button: btn_video01,
                name: 'video-01',
                uri: 'doctor.mp4'
            });

            this.setHandleMouseDown(btn_video02, execute, {
                occ_button: btn_video02,
                name: 'video-02',
                uri: 'example.mp4'
            });

            this.setHandleMouseDown(btn_video03, execute, {
                occ_button: btn_video03,
                name: 'video-03',
                uri: 'vr-boy.mp4'
            });

            this.setHandleMouseDown(btn_video04, execute, {
                occ_button: btn_video04,
                name: 'video-04',
                uri: 'vr-girl.mp4'
            });

            this.setHandleMouseDown(btn_video05, execute, {
                occ_button: btn_video05,
                name: 'video-05',
                uri: 'doctor.mp4'
            });

            this.setHandleMouseDown(btn_video06, execute, {
                occ_button: btn_video06,
                name: 'video-06',
                uri: 'example.mp4'
            });
        });
    };

    /**
     * REVIEW
     */
    initTour = () => {
        this.defaultInit(() => {
            const {
                btn_video01,
                btn_video02
            } = this.getFrame();

            const execute = (event, options) => {
                let occ_button = this.getObject(options, 'occ_button');
                this.openTour(occ_button, options);
            };

            this.setHandleMouseDown(btn_video01, execute, {
                occ_button: btn_video01,
                name: 'video-01',
                uri: 'https://dlightvr.com.br/fibra/florida/36_studio'
            });

            this.setHandleMouseDown(btn_video02, execute, {
                occ_button: btn_video02,
                name: 'video-02',
                uri: 'https://dlightvr.com.br/fibra/florida/33_apto/'
            });
        });
    };

    /**
     * REVIEW
     * @param current_page
     */
    initImplantationAndOrientation = (current_page) => {
        this.defaultPaginateInit(() => {
            const
                _this_current = this.get(),
                {current_name, color_icon} = this.props,
                {paginate, paginates} = this.getPaginate();

            if (current_page === 'implantacao') {
                AllTap.$stagePin({
                    current_name: current_name,
                    xml: this.verifyField(paginate, 'xml'),
                    content_text: this.verifyField(paginate, 'content_text')
                }).mainPin();

                this.destroyTicker('_handleZoom');
            } else if (current_page === 'orientacao') {
                AllTap.$stageSun({
                    current_name: current_name,
                    current_page: current_page
                }).mainSun();

                this.destroyTicker('_handleZoom');
            } else if (current_page === 'planta') {
                AllTap.$stageZoom({current_name: current_name}).mainZoom();
            }

            for (let property of paginates) {
                this.$helpersIcon.setIcon(_this_current, color_icon, property.frame);
            }

            this.$helpersIcon.disabledAnimate(_this_current)(paginate.frame);
        });
    };

    /**
     * REVIEW
     * Paginate.
     * Included stagePaginate and helpersIcon color.
     */
    initSlide = () => {
        this.defaultPaginateInit(() => {
            const
                _this_current = this.get(),
                {color_icon} = this.props,
                occ_pseudo_frame = this.verifyField(_this_current, 'occ_pseudo_frame01'),
                btn_frame = this.verifyField(_this_current, 'btn_frame01');

            this.$helpersIcon.disabledAnimate(_this_current)(1, 'frame');

            this.$helpersIcon.setIcon(_this_current, color_icon, 1);

            this.$helpersIcon.setIcon(_this_current, color_icon, 2);

            this.$helpersIcon.setIcon(_this_current, color_icon, 3);

            occ_pseudo_frame && (occ_pseudo_frame.visible = true);

            btn_frame && (btn_frame.visible = false);
        }, true);
    };

    /**
     * REVIEW
     * Single page.
     * Included helpersIcon color.
     */
    initProject = () => {
        this.defaultInit(() => {
            const
                {occ_project: {occ_project_01, occ_project_02, occ_project_03}} = this.getFrame(),
                {color_icon} = this.props;

            this.setHandleMouseDown(occ_project_01.btn_more, () => {
                (occ_project_02.currentLabel === 'complete') && occ_project_02.gotoAndPlay('complete');
                (occ_project_03.currentLabel === 'complete') && occ_project_03.gotoAndPlay('complete');

                occ_project_01.gotoAndPlay('start');
            }, null, `${occ_project_01.name}_more`);

            this.setHandleMouseDown(occ_project_01.btn_less, () => {
                occ_project_01.gotoAndPlay('complete');
            }, null, `${occ_project_01.name}_less`);

            this.$helpersIcon.setIcon(occ_project_01, color_icon);
            this.$helpersIcon.setIcon(occ_project_01.btn_more, color_icon);

            this.setHandleMouseDown(occ_project_02.btn_more, () => {
                (occ_project_01.currentLabel === 'complete') && occ_project_01.gotoAndPlay('complete');
                (occ_project_03.currentLabel === 'complete') && occ_project_03.gotoAndPlay('complete');

                occ_project_02.gotoAndPlay('start');
            }, null, `${occ_project_02.name}_more`);

            this.setHandleMouseDown(occ_project_02.btn_less, () => {
                occ_project_02.gotoAndPlay('complete');
            }, null, `${occ_project_02.name}_less`);

            this.$helpersIcon.setIcon(occ_project_02, color_icon);
            this.$helpersIcon.setIcon(occ_project_02.btn_more, color_icon);

            this.setHandleMouseDown(occ_project_03.btn_more, () => {
                (occ_project_01.currentLabel === 'complete') && occ_project_01.gotoAndPlay('complete');
                (occ_project_02.currentLabel === 'complete') && occ_project_02.gotoAndPlay('complete');

                occ_project_03.gotoAndPlay('start');
            }, null, `${occ_project_03.name}_more`);

            this.setHandleMouseDown(occ_project_03.btn_less, () => {
                occ_project_03.gotoAndPlay('complete');
            }, null, `${occ_project_03.name}_less`);

            this.$helpersIcon.setIcon(occ_project_03, color_icon);
            this.$helpersIcon.setIcon(occ_project_03.btn_more, color_icon);
        });
    };

    initSector = () => {
        this.defaultInit(() => {
            const {occ_line, btn_01, btn_02, btn_03, btn_04, btn_06} = this.getFrame();

            this.setHandleMouseDown(btn_01, () => {
                this.gotoAndStopFrame(occ_line, 1);
                occ_line.occ_01.gotoAndPlay('start');
            });

            this.setHandleMouseDown(btn_02, () => {
                this.gotoAndStopFrame(occ_line, 2);
                occ_line.occ_02.gotoAndPlay('start');
            });

            this.setHandleMouseDown(btn_03, () => {
                this.gotoAndStopFrame(occ_line, 3);
                occ_line.occ_03.gotoAndPlay('start');
            });

            this.setHandleMouseDown(btn_04, () => {
                this.gotoAndStopFrame(occ_line, 4);
                occ_line.occ_04.gotoAndPlay('start');
            });

            this.setHandleMouseDown(btn_06, () => {
                this.gotoAndStopFrame(occ_line, 6);
                occ_line.occ_06.gotoAndPlay('start');
            });
        });
    };

    initExternal = () => {
        this.defaultPaginateInit(() => {
            const
                _this_current = this.get(),
                {color_icon} = this.props,
                occ_pseudo_frame = this.verifyField(_this_current, 'occ_pseudo_frame01'),
                btn_frame = this.verifyField(_this_current, 'btn_frame01'),
                children = this.verifyField(_this_current, 'occ_frame_03.occ_external.children');

            this.$helpersIcon.disabledAnimate(_this_current)(1, 'frame');

            this.$helpersIcon.setIcon(_this_current, color_icon, 1);

            this.$helpersIcon.setIcon(_this_current, color_icon, 2);

            this.$helpersIcon.setIcon(_this_current, color_icon, 3);

            occ_pseudo_frame && (occ_pseudo_frame.visible = true);

            btn_frame && (btn_frame.visible = false);

            let external = {
                '01': {
                    name: 'ALLTAP',
                    uri: 'https://www.alltap.com.br'
                },
                '02': {
                    name: 'ANIMATE CSS',
                    uri: 'https://animate.style/'
                },
                '03': {
                    name: 'BOOTSTRAP 5',
                    uri: 'https://getbootstrap.com/docs/5.0/getting-started/introduction'
                },
                '04': {
                    name: 'REACT JS',
                    uri: 'https://pt-br.legacy.reactjs.org'
                },
                '05': {
                    name: 'A-FRAME',
                    uri: 'https://aframe.io'
                },
                '06': {
                    name: 'CREATEJS',
                    uri: 'https://createjs.com'
                },
                '07': {
                    name: 'ADOBE ANIMATE',
                    uri: 'https://www.adobe.com/br/products/animate.html'
                }
            }

            if (this.isArrayIf(children)) {
                for (let property of children) {
                    let
                        name = property.name,
                        number = this.toNumber(name),
                        occ = this.padWithLeadingZeros(number, 2);

                    this.openExternal(property, external[occ]);
                }
            }
        }, true);
    };
}

/**
 *
 * @type {{}}
 */
PageCurrent.propTypes = {
    current_name: PropTypes.string,
    frame: PropTypes.number,
    color_icon: PropTypes.string
};

/**
 *
 * @type {{}}
 */
PageCurrent.defaultProps = {
    current_name: null,
    frame: indexConfig.init.frame,
    color_icon: pageConfig.button.color_icon
};

/**
 *
 * @type {{}}
 * @private
 */
PageCurrent._this = {};

/**
 *
 * @param ClassObject
 * @param className {className: 'className'}
 * @returns {function(*): function({}=): *} pass _this ClassMain (required) and props {} (optional)
 */
export default WithType(PageCurrent, {className: 'PageCurrent'});
